module.exports = __webpack_public_path__ + "static/media/antivirus.dfc6cb64.png";